import { render, staticRenderFns } from "./FavouriteAlbums.vue?vue&type=template&id=f2afa4bc"
import script from "./FavouriteAlbums.vue?vue&type=script&lang=js"
export * from "./FavouriteAlbums.vue?vue&type=script&lang=js"
import style0 from "./FavouriteAlbums.vue?vue&type=style&index=0&id=f2afa4bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports